import { Route } from "found";

import { SearchResultsPage } from "./SearchResults/SearchResults";

// TODO read about query in routes and farce router

const routes = (
  <Route
    path="search"
    Component={SearchResultsPage}
    data={{
      routeName: "search"
    }}
    prepareVariables={(params, { location }) => ({
      ...params,
      queryName: location.query.name
    })}
  />
);

export default routes;
